export default "__VITE_ASSET__616600b9__"